<template>
    <nav class="navbar-container font-gothic-cond">

        <!-- Logo mobile -->
        <router-link to="/" class="navbar-brand d-md-none mobile-logo">
            <img src="@/assets/images/logo_black.png" alt="Shelter Logo" class="navbar-logo" />
        </router-link>

        <!-- Mobile Hamburger Menu -->
        <button class="navbar-toggle d-lg-none" @click="toggleMenu">
            <span class="navbar-toggle-icon" :class="{ 'open': isMenuOpen }"></span>
        </button>

        <!-- Desktop Navigation Links (Left) -->
        <div class="navbar-links d-none d-lg-flex">
            <router-link v-for="(link, index) in leftLinks" :key="index" :to="link.path" class="nav-link fw-normal"
                :class="{ 'active': $route.path === link.path }">
                {{ link.text }}
            </router-link>
        </div>

        <!-- Logo (center) -->
        <router-link to="/" class="navbar-brand mx-3 d-none d-sm-none d-md-block ">
            <img src="@/assets/images/logo_black.png" alt="Sheltr Logo" class="navbar-logo center-logo" />
        </router-link>

        <!-- Desktop Navigation Links (Right) -->
        <div class="navbar-links d-none d-lg-flex">
            <!-- <router-link v-for="(link, index) in rightLinks" :key="index" :to="link.path" class="nav-link fw-normal"
                :class="{ 'active': $route.path === link.path }">
                {{ link.text }}
            </router-link> -->

            <!-- Desktop User Dropdown -->
            <div class="user-dropdown" v-if="isAuthenticated">
                <button class="user-dropdown-toggle" @click="toggleUserDropdown">
                    Hi {{ userFirstName }}
                    <i class="fas fa-caret-down" :class="{ 'rotate': isUserDropdownOpen }"></i>
                </button>
                <div class="user-dropdown-menu" v-show="isUserDropdownOpen">
                    <router-link to="/profile" class="dropdown-item" @click="closeUserDropdown">Profile</router-link>
                    <router-link to="/dashboard" class="dropdown-item"
                        @click="closeUserDropdown">Dashboard</router-link>
                    <button class="dropdown-item" @click="signOut">Sign Out</button>
                </div>
            </div>
            <button v-else class="btn btn-nav-cta" @click="signIn">
                Sign In
            </button>
        </div>

        <!-- Mobile Menu (Overlay) -->
        <div class="mobile-menu" :class="{ 'open': isMenuOpen }" @click="closeMenu">
            <div class="mobile-menu-content font-charlie" @click.stop>
                <div class="mobile-links">
                    <!-- User info for mobile -->
                    <div class="mobile-links" v-if="isAuthenticated">
                        <span class="mobile-user-name">Hi {{ userFirstName }}</span>
                    </div>

                    <!-- Profile and Dashboard links for authenticated users -->
                    <template v-if="isAuthenticated">
                        <router-link to="/profile" class="mobile-link" @click="closeMenu">Profile</router-link>
                        <router-link to="/dashboard" class="mobile-link" @click="closeMenu">Dashboard</router-link>
                    </template>

                    <!-- Regular links -->
                    <router-link v-for="(link, index) in allLinks" :key="index" :to="link.path" class="mobile-link"
                        @click="closeMenu" :class="{ 'active': $route.path === link.path }">
                        {{ link.text }}
                    </router-link>

                    <!-- Sign In/Sign Out button -->
                    <button v-if="isAuthenticated" class="btn btn-nav-cta" @click="signOut">
                        Sign Out
                    </button>
                    <button v-else class="btn btn-nav-cta" @click="signIn">
                        Sign In
                    </button>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { useAppStore } from '@/stores/appstore';

export default {
    data() {
        return {
            store: useAppStore(),
            isMenuOpen: false,
            isHidden: false,
            isUserDropdownOpen: false,            
            leftLinks: [
                { text: 'Listings', path: '/admin/listings' },
                { text: 'Requests', path: '/admin/requests' },
                { text: 'Subscriptions', path: '/admin/subscriptions' },
                { text: 'Payments', path: '/admin/payments' },
                { text: 'Users', path: '/admin/users' },

            ],
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                this.isHidden = this.$route.meta.hideNavBar ? true : false;
            },
        },
    },
    computed: {
        // To this:
        isAuthenticated() {
            return this.store.IsAuthenticated;
        },
        User() {
            return this.store.User;
        },
        userFirstName() {
            return this.store.User?.firstname || 'User';
        },

        allLinks() {
            return [...this.leftLinks];
        },
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
            document.body.style.overflow = this.isMenuOpen ? 'hidden' : 'auto';
        },
        closeMenu() {
            this.isMenuOpen = false;
            document.body.style.overflow = 'auto';
        },
        toggleUserDropdown() {
            this.isUserDropdownOpen = !this.isUserDropdownOpen;
        },
        closeUserDropdown() {
            this.isUserDropdownOpen = false;
        },
        signIn() {
            this.$router.push('/login');
        },
        signOut() {
            this.store.logOut();
            this.closeMenu();
            this.closeUserDropdown();
            this.$router.push('/');
        }
    },

    mounted() {
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.isUserDropdownOpen = false;
            }
        });
    }
};
</script>

<style scoped>
.fw-normal {
    font-weight: 400 !important;
}

.btn-nav-cta {
    background-color: #E31662;
    color: #fff;
    padding: 10px 30px 10px 30px;
    font-size: 1rem;
}

.mobile-logo {
    order: -1;
    margin-right: auto;
}

.navbar-toggle {
    order: 1;
    margin-left: auto;
}

@media (max-width: 991.98px) {
    .navbar-brand.mobile-logo {
        margin-left: 1rem;
    }

    .navbar-toggle {
        margin-right: 1rem;
    }
}

.navbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.2rem 1.5rem;
    background-color: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 1000;
}

.navbar-brand {
    display: flex;
    align-items: center;
    z-index: 1001;
}

.navbar-logo {
    height: 32px;
    transition: transform 0.3s ease;
}

.navbar-logo:hover {
    transform: scale(1.05);
}

.center-logo {
    margin: 0 1rem;
}

.navbar-links {
    display: flex;
    align-items: center;
    gap: 2rem;
}

.nav-link {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    font-size: 0.95rem;
    position: relative;
    padding: 0.5rem 0;
    transition: color 0.3s ease;
}

.nav-link:hover {
    color: #000;
}

.nav-link::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #000;
    transition: width 0.3s ease;
}

.nav-link:hover::after,
.nav-link.active::after {
    width: 100%;
}

.navbar-toggle {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    z-index: 1001;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.navbar-toggle-icon {
    display: block;
    width: 24px;
    height: 2px;
    background-color: #000;
    position: relative;
    transition: all 0.3s ease;
}

.navbar-toggle-icon::before,
.navbar-toggle-icon::after {
    content: '';
    position: absolute;
    width: 24px;
    height: 2px;
    background-color: #000;
    transition: all 0.3s ease;
}

.navbar-toggle-icon::before {
    transform: translateY(-6px);
}

.navbar-toggle-icon::after {
    transform: translateY(6px);
}

.navbar-toggle-icon.open {
    background-color: transparent;
}

.navbar-toggle-icon.open::before {
    transform: rotate(45deg);
}

.navbar-toggle-icon.open::after {
    transform: rotate(-45deg);
}

.mobile-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    z-index: 1001;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
}

.mobile-menu.open {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
}

.mobile-menu:not(.open) {
    pointer-events: none;
}

.mobile-menu-content {
    position: absolute;
    top: 0;
    right: 0;
    width: 80%;
    max-width: 300px;
    height: 100%;
    background-color: white;
    padding: 5rem 2rem 2rem;
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu.open .mobile-menu-content {
    transform: translateX(0);
}

.mobile-links {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.mobile-link {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    font-size: 1.1rem;
    padding: 0.5rem 0;
    transition: color 0.3s ease;
}

.mobile-link:hover,
.mobile-link.active {
    color: #000;
}

.mobile-button {
    background-color: #f0f0f0;
    color: #757272;
    font-weight: 400;
    font-size: 0.95rem;
    border: none;
    padding: 0.8rem 1.5rem;
    border-radius: 4px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 1rem;
    width: 100%;
}

.mobile-button:hover {
    background-color: #e0e0e0;
    color: #555;
}

.user-dropdown {
    position: relative;
    display: inline-block;
}

.user-dropdown-toggle {
    background: none;
    border: none;
    color: #333;
    font-weight: 500;
    font-size: 0.95rem;
    padding: 0.5rem 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
}

.user-dropdown-toggle:hover {
    color: #000;
}

.user-dropdown-toggle i {
    transition: transform 0.3s ease;
}

.user-dropdown-toggle i.rotate {
    transform: rotate(180deg);
}

.user-dropdown-menu {
    position: absolute;
    right: 0;
    top: 100%;
    background-color: white;
    min-width: 160px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    z-index: 1002;
    padding: 0.5rem 0;
}

.dropdown-item {
    display: block;
    padding: 0.5rem 1rem;
    color: #333;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
}

.dropdown-item:hover {
    background-color: #f5f5f5;
    color: #000;
}

.mobile-user-name {
    font-weight: 500;
    font-size: 1.1rem;
    color: #c0c0c0;
}

.mobile-button i.fa-sign-out-alt {
    margin-right: 0.5rem;
}

@media (max-width: 991.98px) {
    .navbar-container {
        padding: 1rem 1.5rem;
    }
}

@media (max-width: 575.98px) {
    .navbar-container {
        padding: 1rem;
    }

    .mobile-menu-content {
        width: 85%;
    }
}
</style>
